// no $m: the page only sends the visitor home
setTimeout(() => location.replace('/'), 3000);
